import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PropertieUtil } from 'app/util/properties.model';
import { UtilidadesService } from 'app/util/utilidades.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    private _httpClient: HttpClient,
    private _utilidadesService: UtilidadesService
  ) { }

  getListTipo() {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_tablamaestra + 'listrest',
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListTipoIdTabla(idTabla: number) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_tablamaestra + 'listrestid?id=' + idTabla,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListTipoParameters(idtablamaestra: any, idtabla: any, iditem: any, idsuperior: any, orden: any) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_tablamaestra + 'listrestparameters?idtablamaestra=' + idtablamaestra + '&idtabla=' + idtabla + '&iditem=' + iditem + '&idsuperior=' + idsuperior + '&orden=' + orden,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getLisDetalleControlSistema(tipocontrol: any, idasunto: any, fechasubsanar: any, fechaautorizar: any, fechajefe: any) {
    return this._httpClient.get(PropertieUtil.val_servidor + PropertieUtil.ws_tablamaestra + 'listdetallecontrolsistemasp?' + 'tipocontrol=' + tipocontrol + '&idasunto=' + idasunto + '&fechasubsanar=' + fechasubsanar + '&fechaautorizar=' + fechaautorizar + '&fechajefe=' + fechajefe,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListarhorariotrabajo() {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_tablamaestra + 'listarhorariotrabajo',
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListSede() {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_sede + 'listrest',
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListPais() {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_ubigeo + 'listpais',
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListDepartamento(id: any) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_ubigeo + 'listdep?id=' + id,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListProvincia(id: any) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_ubigeo + 'listprov?id=' + id,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListDistrito(id: any) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_ubigeo + 'listdistr?id=' + id,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListDependencia(iddependencia: any, iddependsuperior: any, idttipodependencia: any) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_dependencia + 'listdependenciaparam?'
      + 'iddependencia=' + iddependencia + '&iddependsuperior=' + iddependsuperior + '&idttipodependencia=' + idttipodependencia,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListPersonal(idpersonal: any, iddependencia: any, documentoidentidad: any, idtestado: any) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_personal + 'listpersonal?'
      + 'idpersonal=' + idpersonal + '&iddependencia=' + iddependencia + '&documentoidentidad=' + documentoidentidad + '&idtestado=' + idtestado,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getListPersonalFechaHasta(idpersona, idpersonal, iddependencias, idttipocontrato, idtestado, documentoidentidad, fechahasta, tipoconsulta) {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_personal + 'listarPersonalFechaHasta',
      {
        params: {
          idpersona: idpersona,
          idpersonal: idpersonal,
          iddependencias: iddependencias,
          idttipocontrato: idttipocontrato,
          idtestado: idtestado,
          documentoidentidad: documentoidentidad,
          fechahasta: fechahasta,
          tipoconsulta: tipoconsulta
        }
      }
    );
  }

  getLisDependenciaPersonal(fechahasta: any) {
    return this._httpClient.get(PropertieUtil.val_servidor + PropertieUtil.ws_dependencia + 'listrestdependenciapersonal?fechahasta=' + fechahasta,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getLisContenedor(idcontenedor: any, idtabla: any, idttipo: any, idreferencia: any) {
    return this._httpClient.get(PropertieUtil.val_servidor + PropertieUtil.ws_contenedor + 'listrestparametro?'
      + 'idcontenedor=' + idcontenedor + '&idtabla=' + idtabla + '&idttipo=' + idttipo + '&idreferencia=' + idreferencia,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

  getLisFilesForName(name) {
    return this._httpClient.get(PropertieUtil.val_servidor_upload_drive + 'listfilesfornameanddep?dep=rrhh&' + 'name=' + name);
  }

  getObjectHoraServidor(): Promise<any> {

    return new Promise((resolve, reject) => {

      this._httpClient.get(PropertieUtil.val_servidor + PropertieUtil.ws_utilitarios + 'horaservidor').subscribe(data => {

        if (data["Status"] == "200") {

          let fechaser = new Date(data["Result"]);

          let objHoraServ = {
            fechaservidor: fechaser,
            hora: fechaser.getHours(),
            minuto: fechaser.getMinutes(),
            segundo: fechaser.getSeconds()
          };

          resolve(objHoraServ)

        } else {

          let fechaser = new Date();

          let objHoraServ = {
            fechaservidor: fechaser,
            hora: fechaser.getHours(),
            minuto: fechaser.getMinutes(),
            segundo: fechaser.getSeconds()
          };

          resolve(objHoraServ)

        }

      }, error => {
        console.log(<any>error);
        reject()
      })
    })
  }

  saveordupdatecondenedor(dto): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.post(PropertieUtil.val_servidor + PropertieUtil.ws_contenedor + 'saveorupdate', dto, this._utilidadesService.getHttpOptionsHeaderWithToken())
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  uploadFile(idreferencia: any, idtabla: any, idttipo: any, urlImport: any, uploadfile: File): Promise<any> {

    let data = new FormData();
    data.append('idreferencia', idreferencia);
    data.append('idtabla', idtabla);
    data.append('idttipo', idttipo);
    data.append('urlImport', urlImport);
    data.append('uploadfile', uploadfile, uploadfile.name);
    data.append('token', window.localStorage.getItem('token'));

    return new Promise((resolve, reject) => {
      this._httpClient.post(PropertieUtil.val_servidor + PropertieUtil.ws_contenedor + 'uploadContendor', data)
        .subscribe((response: any) => {
          console.log(response["Status"]);
          resolve(response["Status"]);
        }, reject);
    });
  }

  uploadFiles(idreferencia: any, idtabla: any, idttipo: any, urlImport: any, uploadfile: any): Promise<any> {

    let data = new FormData();
    data.append('idreferencia', idreferencia);
    data.append('idtabla', idtabla);
    data.append('idttipo', idttipo);
    data.append('urlImport', urlImport);
    data.append('token', window.localStorage.getItem('token'));

    for (let i = 0; i < uploadfile.length; i++) {
      data.append('uploadfile', uploadfile[i], uploadfile[i].name);
    }

    return new Promise((resolve, reject) => {
      this._httpClient.post(PropertieUtil.val_servidor + PropertieUtil.ws_contenedor + 'uploadContendors', data)
        .subscribe((response: any) => {
          console.log(response["Status"]);
          resolve(response["Status"]);
        }, reject);
    });
  }

  uploadFileDrive(uploadfile: File, parents: any, idreferencia: any, idtabla: any, idttipo: any): Promise<any> {

    let data = new FormData();
    data.append('parents', parents);
    data.append('idreferencia', idreferencia);
    data.append('idtabla', idtabla);
    data.append('idttipo', idttipo);
    data.append('token', localStorage.getItem("token"));
    data.append('method', "");
    data.append('archivo', uploadfile, uploadfile.name);

    return new Promise((resolve, reject) => {
      this._httpClient.post(PropertieUtil.val_servidor_upload_drive + 'upload-drive', data)
        .subscribe((response: any) => {
          console.log(response);
          resolve(response);
          // console.log(response["Status"]);
          // resolve(response["Status"]);
        }, reject);
    });
  }

  uploadFilesDrive(uploadfiles: any, parents: any, idreferencia: any, idtabla: any, idttipo: any): Promise<any> {

    return new Promise((resolve, reject) => {

      let data = new FormData();
      data.append('parents', parents);
      data.append('idreferencia', idreferencia);
      data.append('idtabla', idtabla);
      data.append('idttipo', idttipo);
      data.append('token', localStorage.getItem("token"));
      data.append('method', "");

      const files: Array<File> = uploadfiles;
      console.log(files)

      var bar = new Promise((resolve1, reject1) => {

        uploadfiles.forEach((value, index, array) => {
          data.append('archivos', value, value.name);
          // this.uploadFileDrive(value, 1, Constants.val_tabla_documento, Constants.val_const_tipo_archivo_otros);
          if (index === array.length - 1) resolve1(null);
        });

      });

      bar.then(() => {
        this._httpClient.post(PropertieUtil.val_servidor_upload_drive + 'uploads-drive', data)
          .subscribe((response: any) => {
            console.log(response);
            resolve(response);
            // console.log(response["Status"]);
            // resolve(response["Status"]);
          }, reject);

      });

    });
  }

  getComunicadoVigente() {
    return this._httpClient.get<Object>(PropertieUtil.val_servidor + PropertieUtil.ws_tablamaestra + 'verificarcomunicadoprogramado',
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    );
  }

}
